import { format } from "date-fns";
import {
  WHATSAPP_TEMPLATE_LANGUAGE_DEFAULT,
  WHATSAPP_TEMPLATE_LANGUAGES_OPTIONS,
} from "features/WhatsappTemplate/modules/LanguageSelectionDropdown/LanguageSelectionDropdown.constants";
import React from "react";
import {
  date_fns_formats,
  parseDateStringForGivenTz,
} from "utils/dateTimeUtils";
import { WhatsappTemplateTypeColumn } from "../../modules/WhatsappTemplateTypeColumn/WhatsappTemplateTypeColumn";
import {
  TemplatesActionField,
  TemplateStatusChip,
} from "./ListingTableComponents";
import { whatsappSubTabsMapping } from "../../list/constants";

export const table_col_keys = {
  display_title: "display_title",
  template_type: "template_type",
  session_date: "session_date",
  first_join_time: "first_join_time",
  last_leave_time: "last_leave_time",
  notification_type: "notification_type",
  cdb_type: "cdb_type",
};

export const formatTime = (val) =>
  format(parseDateStringForGivenTz(val), date_fns_formats.hour_min__AMPM);

export const getTableConfigTemplates = (id) => [
  {
    field: table_col_keys.display_title,
    headerName: "Template name",
    fixed: "left",
  },
  {
    field: table_col_keys.notification_type,
    headerName: "Type",
    valueFormatter: WhatsappTemplateTypeColumn,
  },
  {
    field: table_col_keys.session_date,
    headerName: "Language",
    valueFormatter: (record) =>
      WHATSAPP_TEMPLATE_LANGUAGES_OPTIONS?.find(
        (item) => item.value === record.locale
      )?.label || WHATSAPP_TEMPLATE_LANGUAGE_DEFAULT.label,
  },
  {
    field: table_col_keys.first_join_time,
    headerName: "Status",
    valueFormatter: (record) => {
      return <TemplateStatusChip status={record?.approval_status} />;
    },
    hidden: true,
  },
  ...(id == whatsappSubTabsMapping.Rejected
    ? [
        {
          field: "rejected_reason",
          headerName: "Rejected Reason",
        },
      ]
    : []),
  {
    field: "",
    headerName: "Actions",
    valueFormatter: (record) => <TemplatesActionField record={record} />,
    isCollapsed: true,
    hidden: true,
    noWrap: true,
    fixed: "right",
    width: "200px",
  },
];
